import React, { FC, useState, useEffect, useContext } from 'react'
import platform from 'platform'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import { getUserData, getTrainingDays } from '../../../../Api/backendApi'
import { getAllUserWatchedVideos } from '../../../../Api/videoApi'

import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface ReportBugInterface {
  closeModal: Function
}

const ReportBug: FC<ReportBugInterface> = ({ closeModal }) => {
  const [userData, setUserData] = useState({})
  const [userTraining, setUserTraining] = useState({})
  const [userWatchedVideos, setUserWatchedVideo] = useState({})

  const getUser = async () => {
    const result: any = await getUserData()

    setUserData(result)
  }

  const getTraining = async () => {
    const result: any = await getTrainingDays()

    setUserTraining(result)
  }

  const getWatchedVideos = async () => {
    const result: any = await getAllUserWatchedVideos()

    setUserWatchedVideo(result)
  }

  useEffect(() => {
    ;(async () => {
      getUser()
      getTraining()
      getWatchedVideos()
    })()
  }, [])

  const findLastWatchedVid = (allWatchedVids: any) => {
    let maxDate: any = 'brak'

    if (
      allWatchedVids !== undefined &&
      allWatchedVids.length !== undefined &&
      allWatchedVids !== null
    ) {
      maxDate = new Date(
        Math.max(
          ...allWatchedVids.map((e: any) => new Date(e.watched_datetime))
        )
      )
    }

    return maxDate
  }

  const findLastLockedVid = (allWatchedVids: any) => {
    let maxDate: any = 'brak'
    if (allWatchedVids != undefined && allWatchedVids.length != undefined) {
      maxDate = new Date(
        Math.max(...allWatchedVids.map((e: any) => new Date(e.locked_datetime)))
      )
    }

    return maxDate
  }

  const composeUserDetails = (
    userInfo: any,
    userTraining: any,
    userWatchedVideos: any
  ) => {
    let sortedTrainingDays = []

    if (userTraining && userTraining.trainingDays != undefined) {
      sortedTrainingDays = userTraining && userTraining.trainingDays.sort()
    }

    const user = {
      id: userInfo && userInfo.id,
      platform: 'Web',
      systemFamily: platform.os.family,
      systemVersion: platform.os.version,
      systemArchitecture: platform.os.architecture,
      browserName: platform.name,
      browserVersion: platform.version,
      clientWidth: window.innerWidth,
      clientHeight: window.innerHeight,
      trainingDays: sortedTrainingDays,
      lastWatchedVid: findLastWatchedVid(userWatchedVideos),
      lastLockedVid: findLastLockedVid(userWatchedVideos),
    }

    const issueRequestEmailSubject = 'WEB - Problem techniczny'
    let issueRequestEmailBody =
      '\r\n' +
      '\r\n' +
      'Twoje dane diagnostyczne: ' +
      '\r\n' +
      `UserId: ${userInfo && userInfo.id}` +
      '\r\n' +
      'Platforma: Web' +
      '\r\n' +
      'Przeglądarka: ' +
      `${platform.name} ${platform.version}` +
      '\r\n' +
      'Aktualna rozdzielczość ekranu: ' +
      `${window.innerWidth} x ${window.innerHeight}` +
      '\r\n' +
      'Dni treningowe: ' +
      `${sortedTrainingDays}` +
      '\r\n' +
      'Data ostatnio obejrzanego treningu miazga: ' +
      `${findLastWatchedVid(userWatchedVideos)}` +
      '\r\n' +
      'Data zablokowanego treningu: ' +
      `${findLastLockedVid(userWatchedVideos)}`

    // issueRequestEmailBody = encodeURIComponent(issueRequestEmailBody)
    const userData = { formattedData: issueRequestEmailBody, objectData: user }
    return userData
  }

  const userFormattedInfo = composeUserDetails(
    userData,
    userTraining,
    userWatchedVideos
  )

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(userFormattedInfo.formattedData)
      notify.show('Skopiowano dane do schowka.', 'success', 2000)
    } catch (err) {
      notify.show(
        `Pojawił się problem przy kopiowaniu danych do schowka: ${err}`,
        'error',
        2000
      )
    }
  }

  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Zgłoś błąd
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          fSize={isMobile ? '1.3rem' : '1rem'}
          tAlign={isMobile ? 'left' : 'center'}
          width={isMobile ? '90%' : '60%'}
        >
          By zgłosić błąd, proszę wyślij email na adres
          <span className="email"> miazga@fitmatkawariatka.pl</span> zawierający
          opis problemu, oraz dodaj poniższe dane diagnostyczne, które ułatwią
          naprawę problemu.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow margin={'3% 0 1% 0'}>
        <GenericTextSpan
          fSize={isMobile ? '1.3rem' : '1rem'}
          tAlign={isMobile ? 'left' : 'left'}
          width={isMobile ? '90%' : '60%'}
        >
          Dane diagnostyczne:
        </GenericTextSpan>
      </GenericRow>

      <UserDataContainer>
        <GenericRow width={'unset'} margin={'1% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            UserId:{' '}
            <span className="report-bug-data-span">
              {userFormattedInfo.objectData.id}
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Platforma:{' '}
            <span className="report-bug-data-span">
              {userFormattedInfo.objectData.platform}
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Nazwa przeglądarki:{' '}
            <span className="report-bug-data-span">
              {userFormattedInfo.objectData.browserName}
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Wersja przeglądarki:{' '}
            <span className="report-bug-data-span">
              {userFormattedInfo.objectData.browserVersion}
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Rozdzielczość:
            <span className="report-bug-data-span">
              {userFormattedInfo.objectData.clientWidth} x{' '}
              {userFormattedInfo.objectData.clientHeight}
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Dni treningowe:
            <span className="report-bug-data-span">
              [{userFormattedInfo.objectData.trainingDays.join(', ')}]
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Data ostatnio obejrzanego treningu miazga:{' '}
            <span className="date report-bug-data-span">
              {userFormattedInfo.objectData.lastWatchedVid == 'brak'
                ? userFormattedInfo.objectData.lastWatchedVid
                : moment(userFormattedInfo.objectData.lastWatchedVid).format()}
            </span>
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'unset'} margin={'2% 0 0 0'}>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            tAlign={isMobile ? 'left' : 'left'}
          >
            Data ostatnio zablokowanego treningu miazga:
            <span className="date report-bug-data-span">
              {userFormattedInfo.objectData.lastWatchedVid == 'brak'
                ? userFormattedInfo.objectData.lastLockedVid
                : moment(userFormattedInfo.objectData.lastLockedVid).format()}
            </span>
          </GenericTextSpan>
        </GenericRow>
      </UserDataContainer>

      <GenericButton
        width={isMobile ? '90%' : '50%'}
        className="standard"
        margin={'4% auto'}
        justify={'center'}
        onClick={copyToClipboard}
      >
        Skopiuj dane
      </GenericButton>
    </SingleSettingModalBox>
  )
}

export default ReportBug
